export default __webpack_public_path__ + "static/media/FSKoopman-MediumItalic.b5daf181.woff2";